import { getLogger } from '../base/logging/functions';
/**
 * meeting-ui 模块日志。
 */
export default getLogger('app:meeting-ui');
